import { useMemo } from 'react';
import type { ScreenState } from '@hana/ui';

export interface PayrollAccess {
  /** Quyền tiền (lương): không có → `noperm`. */
  money: boolean;
  force: ScreenState | null;
}

const STATES: readonly ScreenState[] = ['ready', 'loading', 'empty', 'error', 'noperm'];

/** Đọc quyền từ chuỗi truy vấn (`?money=view&state=…`), cùng quy ước với vùng tài chính. TODO(A): quyền thật từ phiên đăng nhập. */
export function readPayrollAccess(search: string): PayrollAccess {
  const p = new URLSearchParams(search);
  const st = p.get('state') as ScreenState | null;
  return { money: p.get('money') === 'view', force: st && STATES.includes(st) ? st : null };
}

export function usePayrollAccess(search: string = typeof location === 'undefined' ? '' : location.search): PayrollAccess {
  return useMemo(() => readPayrollAccess(search), [search]);
}

/** Không có quyền tiền thì luôn `noperm`, bất kể `state` ép. */
export function payrollScreenState(a: PayrollAccess): ScreenState {
  if (!a.money) return 'noperm';
  return a.force ?? 'ready';
}
